import {
  SAVE_REQUEST_GAP_MS,
  SAVE_RETRY_DELAY_MS,
  SAVE_RETRY_LIMIT,
} from './constants'

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

export interface SerialWriteResult<T> {
  saved: number
  failed: T[]
  lastError: any
}

/**
 * Runs writes one at a time, with a retry and a gap between requests.
 *
 * The flow endpoints return 500 when writes arrive concurrently — the same
 * behaviour the pipe endpoint has — so a Promise.all over edited rows loses
 * most of them and reports a single error for the batch.
 */
export const writeSerially = async <T>(
  items: T[],
  write: (item: T) => Promise<unknown>,
): Promise<SerialWriteResult<T>> => {
  const failed: T[] = []
  let saved = 0
  let lastError: any = null

  for (const item of items) {
    let ok = false
    for (let attempt = 0; attempt < SAVE_RETRY_LIMIT && !ok; attempt++) {
      try {
        await write(item)
        ok = true
        saved += 1
      } catch (error) {
        lastError = error
        if (attempt < SAVE_RETRY_LIMIT - 1) await sleep(SAVE_RETRY_DELAY_MS)
      }
    }
    if (!ok) failed.push(item)
    await sleep(SAVE_REQUEST_GAP_MS)
  }

  return { saved, failed, lastError }
}
